export default __webpack_public_path__ + "static/media/ACM logo.be63f0a2.svg";